import { Grid, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { SubtypeDPActionsProps } from './props';
import { useSubtypeDPListActions } from './hook';

export const SubtypeDPListActions = ({ id }: SubtypeDPActionsProps) => {
    const { handleEdit } = useSubtypeDPListActions(id);

    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Editar">
                <IconButton size="small" onClick={handleEdit}>
                    <EditIcon type="submit" sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
        </Grid>
    );
};
